import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg404 = (props) => /* @__PURE__ */ _jsxs("svg", {
	role: "img",
	width: 621,
	height: 426,
	viewBox: "0 0 621 426",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_4243_18006)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M466.397 72.4138C551.397 102.282 610.704 160.044 611.889 221.402C612.997 278.709 541.622 322.153 471.933 358.937C409.33 391.98 335.327 414.033 253.898 410.359C164.815 406.341 69.152 388.092 25.8972 338.816C-16.3657 290.67 18.6087 233.152 54.2504 182.921C86.5153 137.449 136.832 99.5092 209.529 80.0173C292.522 57.7648 387.619 44.7318 466.397 72.4138Z",
				fill: "#F5F4F4"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_4243_18006)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M369.423 6.74938C448.146 16.1168 507.277 56.0284 549.342 99.7168C591.473 143.473 618.389 194.899 598.556 244.726C578.977 293.916 514.618 327.574 447.81 354.809C379.723 382.565 302.434 410.709 224.559 397.187C147.976 383.89 107.034 333.969 69.5405 289.129C34.9827 247.799 6.59911 202.608 23.7432 157.018C40.8444 111.542 97.8871 79.43 158.268 53.182C222.296 25.3487 293.369 -2.30043 369.423 6.74938Z",
				fill: "#F5F4F4"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.603 117.688C317.85 117.688 318.861 116.676 318.861 115.429C318.861 114.182 317.85 113.171 316.603 113.171C315.355 113.171 314.344 114.182 314.344 115.429C314.344 116.676 315.355 117.688 316.603 117.688Z",
			fill: "#F5F4F4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 161.15,
			width: 49.9692,
			height: 5.77474,
			rx: 2.88737,
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 554.16,
			y: 286.159,
			width: 51.0456,
			height: 5.77474,
			rx: 2.88737,
			fill: "#D6D6D6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 208.592,
			y: 47.0426,
			width: 28.6537,
			height: 5.77474,
			rx: 2.88737,
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M199.986 334.242C200.677 331.314 198.864 328.38 195.935 327.688C193.007 326.997 190.072 328.81 189.381 331.739C188.69 334.667 190.503 337.602 193.432 338.293C196.36 338.984 199.295 337.171 199.986 334.242Z",
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M308.852 27.481C310.075 26.2588 310.075 24.2771 308.852 23.0549C307.63 21.8327 305.648 21.8327 304.426 23.0549C303.204 24.2771 303.204 26.2588 304.426 27.481C305.648 28.7032 307.63 28.7032 308.852 27.481Z",
			fill: "#D6D6D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M358.755 31.3063C361.764 31.3063 364.204 28.867 364.204 25.8581C364.204 22.8491 361.764 20.4099 358.755 20.4099C355.746 20.4099 353.307 22.8491 353.307 25.8581C353.307 28.867 355.746 31.3063 358.755 31.3063Z",
			fill: "#D6D6D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M593.214 169.113C596.223 169.113 598.662 166.673 598.662 163.664C598.662 160.655 596.223 158.216 593.214 158.216C590.205 158.216 587.765 160.655 587.765 163.664C587.765 166.673 590.205 169.113 593.214 169.113Z",
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.8606 99.0357C23.6613 99.0357 25.121 97.5759 25.121 95.7752C25.121 93.9745 23.6613 92.5148 21.8606 92.5148C20.0599 92.5148 18.6001 93.9745 18.6001 95.7752C18.6001 97.5759 20.0599 99.0357 21.8606 99.0357Z",
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M442.174 335.141C443.975 335.141 445.435 333.681 445.435 331.88C445.435 330.079 443.975 328.62 442.174 328.62C440.373 328.62 438.914 330.079 438.914 331.88C438.914 333.681 440.373 335.141 442.174 335.141Z",
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M566.357 166.925C568.158 166.925 569.618 165.465 569.618 163.664C569.618 161.864 568.158 160.404 566.357 160.404C564.556 160.404 563.097 161.864 563.097 163.664C563.097 165.465 564.556 166.925 566.357 166.925Z",
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.702 219.522C114.502 219.522 115.962 218.062 115.962 216.262C115.962 214.461 114.502 213.001 112.702 213.001C110.901 213.001 109.441 214.461 109.441 216.262C109.441 218.062 110.901 219.522 112.702 219.522Z",
			fill: "#3A2409"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 267.789,
			y: 292.767,
			width: 73.6279,
			height: 77.9589,
			fill: "#777474"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 267.789,
			y: 292.767,
			width: 73.6279,
			height: 77.9589,
			stroke: "#585656",
			strokeWidth: 4.33105
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M212.928 366.395C212.928 360.016 218.099 354.845 224.478 354.845H384.727C391.105 354.845 396.276 360.016 396.276 366.395V370.726H212.928V366.395Z",
			fill: "#777474"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M212.928 366.395C212.928 360.016 218.099 354.845 224.478 354.845H384.727C391.105 354.845 396.276 360.016 396.276 366.395V370.726H212.928V366.395Z",
			stroke: "#585656",
			strokeWidth: 4.33105
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98.1555,
			y: 65.2481,
			width: 412.894,
			height: 245.426,
			rx: 11.5495,
			fill: "#777474"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98.1555,
			y: 65.2481,
			width: 412.894,
			height: 245.426,
			rx: 11.5495,
			stroke: "#585656",
			strokeWidth: 4.33105
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 106.818,
			y: 73.9102,
			width: 395.569,
			height: 202.116,
			rx: 5.77474,
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-19-inside-1_4243_18006",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M106.818 266.78H502.387V292.767C502.387 297.551 498.509 301.429 493.725 301.429H115.48C110.696 301.429 106.818 297.551 106.818 292.767V266.78Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.818 266.78H502.387V292.767C502.387 297.551 498.509 301.429 493.725 301.429H115.48C110.696 301.429 106.818 297.551 106.818 292.767V266.78Z",
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.818 265.337H502.387V268.224H106.818V265.337ZM502.387 301.429H106.818H502.387ZM106.818 301.429V266.78V301.429ZM502.387 266.78V301.429V266.78Z",
			fill: "#D6D6D6",
			mask: "url(#path-19-inside-1_4243_18006)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M302.465 275.238L301.449 277.639L303.943 279.44L302.465 275.238Z",
			fill: "#679E29"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M302.142 278.84L301.588 280.687C301.772 280.872 301.865 281.057 301.865 281.288C301.865 281.472 301.865 281.657 301.772 281.796L305.744 284.52L304.266 280.364L302.142 278.84Z",
			fill: "#679E29"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M301.403 282.211C301.264 282.304 301.172 282.35 301.033 282.35L301.218 284.428L307.591 289.046L306.067 285.444L301.403 282.211Z",
			fill: "#679E29"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M302.188 287.245L304.358 288.723L305.744 288.446L302.095 285.721L302.188 287.245Z",
			fill: "#679E29"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M311.517 282.073C311.101 278.748 308.515 275.653 304.543 273.76C304.497 273.76 304.451 273.714 304.359 273.668C303.758 273.391 301.957 272.467 301.357 272.467C301.311 272.467 301.264 272.467 301.218 272.513C301.126 272.698 298.263 276.669 297.616 280.41C297.154 285.906 299.787 288.815 302.05 290.293C304.497 291.909 307.083 292.232 307.129 292.232H307.176L308.192 295.465L309.808 295.742L307.915 289.923L306.16 288.723L304.266 289.138L301.726 287.43V287.383L301.634 285.398L300.71 284.751V284.705L300.479 282.257C300.479 282.257 300.479 282.257 300.433 282.211C300.11 282.073 299.879 281.749 299.879 281.38C299.833 280.826 300.249 280.364 300.803 280.318C300.895 280.318 300.987 280.318 301.126 280.364L301.726 278.517L300.895 277.87V277.824L302.465 273.668L303.019 274.868C303.066 275.007 308.93 289.277 309.485 290.616C310.362 289.231 310.962 287.938 311.286 286.829C311.655 285.49 311.747 283.874 311.517 282.073Z",
			fill: "#679E29"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.213 91.8808C124.371 91.5306 125.836 89.4975 125.486 87.3396C125.136 85.1818 123.103 83.7164 120.945 84.0665C118.787 84.4167 117.322 86.4498 117.672 88.6076C118.022 90.7655 120.055 92.2309 122.213 91.8808Z",
			fill: "#E23B3B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.183 91.8808C136.341 91.5306 137.806 89.4975 137.456 87.3396C137.106 85.1818 135.073 83.7164 132.915 84.0665C130.757 84.4167 129.292 86.4498 129.642 88.6076C129.992 90.7655 132.025 92.2309 134.183 91.8808Z",
			fill: "#FCE332"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M146.152 91.8808C148.31 91.5306 149.776 89.4975 149.426 87.3396C149.075 85.1818 147.042 83.7164 144.884 84.0665C142.727 84.4167 141.261 86.4498 141.611 88.6077C141.961 90.7655 143.995 92.2309 146.152 91.8808Z",
			fill: "#46CC46"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.381 196.182V182.894L232.728 143.028H244.786V160.746H237.895L224.238 182.401V182.894H261.642V196.182H207.381ZM238.018 206.025V192.122L238.388 186.339V143.028H254.383V206.025H238.018ZM299.72 207.748C293.999 207.727 289.057 206.405 284.894 203.78C280.731 201.155 277.522 197.371 275.266 192.429C273.01 187.487 271.892 181.561 271.913 174.65C271.933 167.718 273.061 161.833 275.297 156.993C277.552 152.154 280.751 148.473 284.894 145.95C289.057 143.428 293.999 142.167 299.72 142.167C305.442 142.167 310.384 143.438 314.547 145.981C318.71 148.504 321.919 152.185 324.175 157.024C326.43 161.864 327.548 167.739 327.528 174.65C327.528 181.602 326.4 187.549 324.144 192.491C321.888 197.433 318.679 201.216 314.516 203.841C310.374 206.446 305.442 207.748 299.72 207.748ZM299.72 193.844C302.673 193.844 305.093 192.306 306.98 189.23C308.887 186.134 309.83 181.274 309.81 174.65C309.81 170.323 309.379 166.785 308.518 164.037C307.656 161.29 306.467 159.259 304.95 157.947C303.432 156.614 301.689 155.948 299.72 155.948C296.767 155.948 294.358 157.445 292.492 160.439C290.625 163.433 289.672 168.17 289.631 174.65C289.61 179.059 290.031 182.688 290.892 185.539C291.753 188.369 292.943 190.461 294.46 191.814C295.998 193.167 297.752 193.844 299.72 193.844ZM338.406 196.182V182.894L363.752 143.028H375.81V160.746H368.92L355.262 182.401V182.894H392.667V196.182H338.406ZM369.043 206.025V192.122L369.412 186.339V143.028H385.407V206.025H369.043Z",
			fill: "#434242"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 44.3938,
			y: 366.85,
			width: 520.417,
			height: 5.77474,
			rx: 2.88737,
			fill: "#585656"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 73.634,
			y: 371.181,
			width: 461.936,
			height: 5.77474,
			rx: 2.88737,
			fill: "#585656"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.7961 37.1517L100.687 47.0426",
			stroke: "#E8E8E8",
			strokeWidth: 1.49127,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.35 37.1517L90.4592 47.0426",
			stroke: "#E8E8E8",
			strokeWidth: 1.49127,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M553.527 335.141L563.096 344.71",
			stroke: "#E8E8E8",
			strokeWidth: 1.44275,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M562.77 335.141L553.201 344.71",
			stroke: "#E8E8E8",
			strokeWidth: 1.44275,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M483.237 12.7049L502.387 31.8555",
			stroke: "#E8E8E8",
			strokeWidth: 2.88737,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M501.735 12.7049L482.585 31.8555",
			stroke: "#E8E8E8",
			strokeWidth: 2.88737,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M569.939 247.541L579.384 256.986",
			stroke: "#D6D6D6",
			strokeWidth: 1.70643,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M579.062 247.541L569.618 256.986",
			stroke: "#D6D6D6",
			strokeWidth: 1.70643,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 64.1967,
			cy: 125.57,
			r: 4.68759,
			stroke: "#D6D6D6",
			strokeWidth: 2.88737
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 100.687,
			cy: 348.817,
			r: 4.68759,
			stroke: "#D6D6D6",
			strokeWidth: 2.88737
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 533.984,
			cy: 125.57,
			r: 3.10096,
			stroke: "#D6D6D6",
			strokeWidth: 2.88737
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_dd_4243_18006)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M131.61 315.335C107.758 318.952 85.4868 302.554 81.868 278.696C78.2501 254.841 94.6561 232.574 118.507 228.954C142.363 225.336 164.634 241.734 168.256 265.591C171.875 289.45 155.469 311.717 131.61 315.335Z",
				fill: "#F5F4F4"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M163.273 237.005L163.273 237.005C144.395 215.496 111.65 213.361 90.1405 232.239C70.5147 249.463 67.0334 278.225 80.9092 299.471C77.752 301.655 74.6555 303.899 71.5914 306.166L71.589 306.168C66.6185 309.861 61.7367 313.649 56.9167 317.504L56.9114 317.508C52.1186 321.378 47.3484 325.291 42.6664 329.307C41.159 330.574 39.6639 331.875 38.1799 333.167C37.3455 333.894 36.5146 334.617 35.6871 335.33C34.4038 336.383 33.2139 337.642 32.3207 339.276C31.8644 340.094 31.5001 340.99 31.2205 341.954L31.2178 341.963L31.2152 341.973C30.9485 342.941 30.7291 344.032 30.7428 345.39L30.7428 345.39C30.7884 349.837 34.0665 353.707 38.6076 354.354C39.9541 354.547 41.0637 354.468 42.0594 354.327L42.0664 354.326L42.0734 354.325C43.0718 354.174 44.0078 353.925 44.872 353.582C46.6151 352.909 48.0153 351.888 49.2247 350.756C50.0387 350.028 50.8643 349.298 51.6936 348.565C53.1684 347.261 54.6545 345.947 56.1064 344.617C60.6945 340.493 65.1919 336.274 69.6522 332.021L69.6567 332.017C74.1052 327.739 78.4971 323.389 82.8032 318.939L82.8048 318.938C85.4516 316.193 88.079 313.412 90.6543 310.565C109.924 327.081 138.891 327.359 158.513 310.133C180.021 291.262 182.153 258.52 163.273 237.005ZM95.5338 296.459L95.5337 296.459C81.5793 280.561 83.1529 256.357 99.0564 242.397C114.96 228.438 139.163 230.019 153.118 245.92C167.07 261.822 165.499 286.026 149.596 299.985C133.693 313.944 109.49 312.364 95.5338 296.459Z",
				fill: "#A6A5A5",
				stroke: "#777474",
				strokeWidth: 2.88737
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_4243_18006",
				x: .536621,
				y: 53.7223,
				width: 617.365,
				height: 366.036,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0666667 0 0 0 0 0.0980392 0 0 0 0 0.156863 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_4243_18006"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_4243_18006",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_4243_18006",
				x: 3.6001,
				y: 0,
				width: 616.605,
				height: 425.685,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 10 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 7.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0666667 0 0 0 0 0.0980392 0 0 0 0 0.156863 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_4243_18006"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_4243_18006",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_dd_4243_18006",
				x: 11.9744,
				y: 215.035,
				width: 182.942,
				height: 172.638,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5.77474 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.33105 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0666667 0 0 0 0 0.0980392 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_4243_18006"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 4.33105,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect2_dropShadow_4243_18006"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 14.4368 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10.8276 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0666667 0 0 0 0 0.0980392 0 0 0 0 0.156863 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_4243_18006",
						result: "effect2_dropShadow_4243_18006"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_4243_18006",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default Svg404;
